import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';

import * as ReportUtils from './report.utils';
import * as fromReportParameterOptions from './report-parameter-options/report-parameter-options.reducer';
import { ReportParameterOptionsEffects } from './report-parameter-options/report-parameter-options.effects';
import * as fromReport from './report/report.reducer';
import { ReportEffects } from './report/report.effects';
import * as fromInViewport from './virtual-scroll/virtual-scroll.reducer';
import { VirtualScrollEffects } from './virtual-scroll/virtual-scroll.effects';
import * as fromReportClone from './report-clone/report-clone.reducer';
import { ReportCloneEffects } from './report-clone/report-clone.effects';
import { ReportCloneSuccessComponent, ReportCloneProgressComponent } from '@mode/reports/util';
import { SharedUtilToastModule } from '@mode/shared/util-toast';
import { ButtonComponent, IconComponent } from '@mode/capra';
@NgModule({
  imports: [
    CommonModule,
    ButtonComponent,
    IconComponent,
    ReportCloneSuccessComponent,
    ReportCloneProgressComponent,
    SharedUtilToastModule,
    EffectsModule.forFeature([ReportParameterOptionsEffects, ReportEffects, ReportCloneEffects, VirtualScrollEffects]),
    StoreModule.forFeature(
      fromReportParameterOptions.reportParameterOptionsFeatureKey,
      fromReportParameterOptions.reducer
    ),
    StoreModule.forFeature(fromReport.reportFeatureKey, fromReport.reducer),
    StoreModule.forFeature(fromInViewport.virtualScrollFeatureKey, fromInViewport.reducer),
    StoreModule.forFeature(fromReportClone.REPORT_CLONE_FEATURE_KEY, fromReportClone.reportCloneReducer),
  ],
})
export class ReportsDomainModule {}

export { ReportUtils };
